// One rule for every printed receipt (the inner-printer receipt, and any other receipt that
// prints an order): "Hide price section on receipt" hides every amount — product and modifier
// prices as well as the totals block — not just the payment breakdown.
class ReceiptHelpers {
  static showsPrices(company) {
    return !company?.is_price_section_hidden_on_receipt;
  }
}

export default ReceiptHelpers;
